module.exports = __webpack_public_path__ + "img/1091264610.abab3883.png";